import styled from 'styled-components';
import { Modal } from '@material-ui/core';

const CouponModalStyled = styled(Modal)`
  .first_line {
    display: flex;
    align-items: center;
    .title {
      font-size: 18px;
      font-weight: 600;
      color: #212121;
      line-height: 25px;
    }
    .close {
      margin-left: auto;
      vertical-align: middle;
    }
  }
  .search_wrapper {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    .single-select {
      width: 240px;
    }
    .companies {
      .MuiTextField-root {
        width: 100%;
      }
    }
    .search_width {
      width: 30%;
    }
    .search_width_integral {
      width: 47%;
      margin-left: 32px;
    }
    .search_width200 {
      width: 200px;
      margin-top: 3px;
    }
    .search_width392 {
      width: 330px;
    }
  }
  .table {
    height: 562px;
    overflow-y: scroll;
    > div {
      padding: 0px;
    }
  }

  .table-content {
    margin-top: 0;
  }
  .modal-btn-wrap {
    display: flex;
    flex-direction: row;
    float: right;
    gap: 16px;
  }
  div.MuiAutocomplete-inputRoot {
    height: 40px;
    div:not(:first-child):not(.MuiAutocomplete-endAdornment) {
      display: none;
    }
  }
  div.MuiAutocomplete-tag {
    height: 22px;
    font-size: 12px;
    text-align: right;
  }
  span.MuiAutocomplete-tag {
    display: block;
  }
  .css-1q60rmi-MuiAutocomplete-endAdornment {
    display: flex;
    .MuiIconButton-root {
      width: 16px;
      height: 16px;
    }
    .MuiSvgIcon-root {
      width: 16px;
      height: 16px;
    }
  }
  div.MuiAutocomplete-tag {
    height: 22px;
    font-size: 12px;
    text-align: right;
  }
  span.MuiAutocomplete-tag {
    display: block;
  }
  .css-1kpdewa-MuiAutocomplete-root .MuiInput-root .MuiInput-input {
    padding: 2px 4px 3px 0;
  }
`;

export default CouponModalStyled;
